var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.069 2.263l-.001 8.296h8.297l2.262.755-2.262.754h-8.297v8.296l-.754 2.263-.754-2.262-.001-8.297H2.263L0 11.313l2.262-.754h8.298V2.263L11.314 0l.755 2.263z",
    fill: "#fff"
  })));
}

export default SvgPlusIcon;